<template>
  <div>
    <div v-if="questions.data.length<=0" style="max-width:720px; margin:auto;">
      <Alert type="info" show-icon style="margin-top:64px; " class="ivu-alert-with-desc">
          We don't have any questions yet
      </Alert>
      <p style="text-align:center; margin-top:64px;"></p>
    </div>
    <div >
      <ul class="list-group lc-default-list-group" style="margin-bottom:0px;">
        <li class="list-group-item" style="border-left: none; border-right:none;" v-for="q in questions.data" :key="q._id">
            <div class="list-group-item-text" style="">
              <p class="item-subtext">{{q.name}} - {{q.location}} - {{q.createdAt | moment('DD.MM.YYYY HH:mm:ss')}}</p>
              <p>{{q.text}}</p>
            </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'

import NewQuestionModal from '@/components/webcast/NewQuestionModal.vue'
import feathersClient from '../../../api/feathers-client'

export default {
  data() {
    return {
      bucket: "inbox",
      form: {},
      isSendQnaActive: false,
      filter: "inbox",
      moderation: true,
      showQuestions: false
    }
  },
  computed: {
    ...mapGetters('webcast', {
      webcast: 'getCopy'
    }),
    ...mapGetters('qna', {
      findQuestionsInStore: 'find'
    }),
    questions() {
      return this.findQuestionsInStore({
        query: {
          webcastId: this.webcast._id,
          bucket: this.filter,
          isApproved: true,
          $sort: {
            createdAt: 1
          }
        }
      })
    }
  },
  created() {
    this.getQuestionList({});
    this.$data.moderation = this.webcast.qnaModeration;
    this.$data.showQuestions = this.webcast.qnaShowQuestions;
    let self = this;
    feathersClient.io.on('connect', function() {
      self.getQuestionList({});
    });
  },
  methods: {
    ...mapActions('qna', {
      questionList: 'find',
      createQuestion: 'create',
      patchQuestionAction: 'patch'
    }),
    ...mapActions('webcast', {
      patchWebcastAction: 'patch'
    }),
    getQuestionList(query, page) {
      query.webcastId = this.webcast._id;
      query.bucket = this.filter
      query.$skip = (page - 1) * 10;
      query.$limit = 1000;
      this.questionList({
        query: query
      }).then((response) => {

      });
    },
    newQuestionModal() {
      this.isSendQnaActive = true;
    },
    newQuestion(data) {
      data.webcastId = this.webcast._id;
      data.bucket = "inbox"
      if(this.webcast.qnaModeration){
        data.isApproved = false;
      } else {
        data.isApproved = true;
      }
      data.isAnswered = false

      this.createQuestion(data).then((response) => {
        this.$Message.success('Your question has been sent');
        this.isSendQnaActive = false;
      });
    },
    changeApproveQna(qId, isApproved) {
      const payload = {
        isApproved: isApproved
      }
      this.patchQuestionAction([qId, payload, {}]).then((response) => {
        if (isApproved) {
          this.$Message.success("Question has been approved");
        } else {
          this.$Message.success("Question has been un-approved");
        }

      }).catch((error) => {
        this.$Message.error("Can't appove question. Error occured");
        console.log(error);
      })
    },
    moveToBucketQna(qId, bucket) {
      const payload = {
        bucket: bucket
      }
      this.patchQuestionAction([qId, payload, {}]).then((response) => {
        this.$Message.success("Question has been moved.");
      }).catch((error) => {
        this.$Message.error("Can't update question. Error occured");
        console.log(error);
      })
    },
    updateFilter() {
      this.getQuestionList({});
    },
    toggleQuestionVisibility(){
      const payload = {
        qnaShowQuestions: this.showQuestions
      }

      this.patchWebcastAction([this.webcast._id, payload, {}]).catch((error)=>{
        this.$Message.error("Can't update! error occured");
        console.log(error);
      })
    },
    toggleModeration(){
      const payload = {
        qnaModeration: this.moderation
      }

      this.patchWebcastAction([this.webcast._id, payload, {}]).catch((error)=>{
        this.$Message.error("Can't change moderation, error occured");
        console.log(error);
      })
    }

  }
}
</script>

<style>

</style>
